export default __webpack_public_path__ + "static/media/GullsCh6.53018a34.svg";